'use client';

import { c as _c } from "react/compiler-runtime";
import { DollarSign, Receipt, Trophy, Zap as TronIcon } from 'lucide-react';
import AwardHistory from '../../components/awards/AwardHistory';
import EarnTrons from '../../components/products/EarnTrons';
import PurchaseHistory from '../../components/products/PurchaseHistory';
import TronsTabContent from '../../components/products/TronsTabContent';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import MultiPage, { type SubpagesObjectType } from '../../layouts/MultiPage';
type ProductsProps = {
  slug?: string;
  basePath: string;
  backPath?: string;
};
const Products = t0 => {
  const $ = _c(9);
  const {
    slug,
    basePath,
    backPath
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      title: "Trons",
      slug: "my",
      icon: <div className="transition-transform duration-200 hover:rotate-[5deg] hover:scale-[1.05]"><TronIcon size={20} className="text-textSecondary" /></div>,
      component: <TronsTabContent />
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="ease-[var(--ease-spring-bouncy)] transition-transform duration-300 hover:rotate-[15deg] hover:scale-[1.2]"><DollarSign size={20} className="text-textSecondary" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      title: "Earn Trons",
      icon: t2,
      slug: "earn",
      component: <EarnTrons />
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      title: "Purchase History",
      slug: "purchases-history",
      icon: <div className="transition-transform duration-200 hover:scale-[1.05]"><Receipt size={20} className="text-textSecondary" /></div>,
      component: <PurchaseHistory />
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [t1, t3, t4, {
      title: "Awards History",
      slug: "awards-history",
      icon: <div className="transition-transform duration-200 hover:rotate-[5deg] hover:scale-[1.05]"><Trophy size={20} className="text-textSecondary" /></div>,
      component: <AwardHistory />
    }];
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const subpages = t5;
  let t6;
  if ($[5] !== backPath || $[6] !== basePath || $[7] !== slug) {
    t6 = <AppLayout fullWidth={true}><MultiPage title="Trons" subpages={subpages} showHeader={false} slug={slug} basePath={basePath} backPath={backPath} /></AppLayout>;
    $[5] = backPath;
    $[6] = basePath;
    $[7] = slug;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default Products;